/**
 * W07 — Adapter: frozen `CommissionLedgerEntryDto` (E09) → domain entity.
 * All DTO→entity mapping (and its NaN/absent-field hardening) lives here so pages and
 * charts consume only clean, nullable-typed entities (W07 §2 Adapter pattern).
 */
import type { CommissionLedgerEntryDto } from '../../domain/contracts/api.contracts';
import type {
  CommissionLedgerEntry,
  CommissionPoolType,
} from '../../domain/entities/CommissionLedgerEntry';

function finiteOrNull(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function poolType(value: unknown): CommissionPoolType {
  return value === 'BOOKING_POOL' ? 'BOOKING_POOL' : 'INSTALLMENT_POOL';
}

export const CommissionAdapter = {
  toDomain(dto: CommissionLedgerEntryDto): CommissionLedgerEntry {
    return {
      id: String(dto?.id ?? ''),
      sourceUserId: String(dto?.sourceUserId ?? ''),
      sourceUserName: String(dto?.sourceUserName ?? ''),
      sourceTier: dto?.sourceTier,
      earnerTier: dto?.earnerTier,
      installmentNumber: Number.isFinite(Number(dto?.installmentNumber))
        ? Number(dto.installmentNumber)
        : 0,
      poolType: poolType(dto?.commissionType),
      ratePercent: finiteOrNull(dto?.ratePercent),
      // Optional G0.2 fields — absent on legacy rows → null (UI shows the bare rate).
      basePercent: finiteOrNull(dto?.basePercent),
      absorbedPercent: finiteOrNull(dto?.absorbedPercent),
      amount: finiteOrNull(dto?.amount) ?? 0,
      createdAt: String(dto?.createdAt ?? ''),
    };
  },

  toDomainList(dtos: CommissionLedgerEntryDto[] | undefined | null): CommissionLedgerEntry[] {
    if (!Array.isArray(dtos)) return [];
    return dtos.filter(Boolean).map((dto) => CommissionAdapter.toDomain(dto));
  },
};
